(function () {
  'use strict';

  angular.module('sempraWebapp').directive('fromLessThanTo', function() {
    return {
      restrict: 'A',
      require: "ngModel",
      link: function(scope, element, attributes, ngModel) {

        ngModel.$parsers.push(function (value) {
          if(!value || value.length == 0) return;

          var otherValueString = scope.$eval(attributes.fromLessThanTo);

          ngModel.$setValidity('fromLessThanTo', true);

          if (value > new Date(otherValueString)) {
            ngModel.$setValidity('fromLessThanTo', false);
          }

          return value;
        });

      }
    };
  });
})();
